<template>
<main class="row onboarding-wrapper">
    <div class="col-md-12 ob-rightcol">
        <template v-if="validateOfficeUI">
            <div class="primary-heading" >
                Please enter your MLS Office Id
            </div>
            <!-- <div class="secondary-heading mt-1">
                You know that number you thought you’d never be able to memorize...
            </div> -->
            <div class="state-agent">
                <div class="sa-frm-row mt-4 mb-1" >
                    <div class="sa-form-control">
                        <input class="sa-control" type="text" placeholder="Enter your MLS Office Id" @keyup="resetError" v-model = "teamKey"/>
                    </div>
                    <div v-if="errorText == 'enterKey'" class="sa-label error-text" style="text-align:left;">Please enter MLS Office Id</div>
                    <div v-if="errorText == 'wrongFormat'" class="sa-label error-text" style="text-align:left;">MLS Office Id should be a 4 or more digit number.</div>
                    <div v-if="errorText == 'wrongInfo'" class="sa-label error-text" style="text-align:left;"> Sorry, we could not found any information for this MLS Office Id. Please enter a valid one.</div>
                </div>
                <div class="sa-frm-row mb-0">
                    <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                        <button  v-if="!loadingAgentData" class="ob-button" style = "align-items:center" @click = "getTeamDetails">Get Started</button>
                        <div  v-if="loadingAgentData" class="rotate-btn-wrap" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
                <div class="sa-frm-row mt-3">
                    <div class="sa-form-control" style="float:left;width:100%;">
                        <input type="checkbox" id="privacyTerms" v-model="termsOfService" @click="resetError" class="sa-checkbox" name="privacyPolicy" />
                        <div class="sa-label agree-txt-label">
                            <span class="lbl">I accept the <a id="termsOfService" class="cursor-pointer" @click=" showTermsPopup  = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Terms of Service</a>
                            and <a id="privacyPolicy" class="cursor-pointer" @click=" showPrivacyPopup = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Privacy Policy</a>.</span>
                        </div>
                    </div>
                    <div v-if="errorText == 'checkTerms'" class="sa-label error-text" style="text-align:left;">Before using {{orgTitle}}, you must read and agree to our terms of service and privacy policy.</div>
                </div>
            </div>
            <div class="mt-4 region-info-text" >
                {{orgTitle}} is currently available in MN, IA, WI, SD & ND
                request your market here.
            </div>
            <!-- <div class="mt-4 region-info-text" >
                Click here to register as <router-link to="/register">Agent</router-link>
            </div> -->
        </template>
        <template v-if="officeDetailUI">
            <div class="primary-heading" >
                What would you like to name your team
            </div>
            <div class="secondary-heading mt-1">
                Looks like you are part of <span style="font-weight:600;font-size:21px;">{{selectedOffice.results[0].Name}}</span>. Choose a suitable team title, you and other agents can associate to...
            </div>
            <div class="state-agent">
                <div class="sa-frm-row mt-4 mb-1" >
                    <div class="sa-form-control">
                        <input class="sa-control" type="text" placeholder="Enter your Team Name" @keyup="resetError" v-model = "officeName"/>
                    </div>
                    <div v-if="errorText == 'enterOffice'" class="sa-label error-text" style="text-align:left;">Please enter Team Name</div>
                </div>
                <div class="sa-frm-row mb-0">
                    <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                        <button  v-if="!loadingAgentData" class="ob-button" style = "align-items:center" @click = "moveToSignup">Proceed</button>
                        <div  v-if="loadingAgentData" class="rotate-btn-wrap" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
                <!-- <div class="sa-frm-row mt-3">
                    <div class="sa-form-control" style="float:left;width:100%;">
                        <input type="checkbox" id="privacyTerms" v-model="termsOfService" @click="resetError" class="sa-checkbox" name="privacyPolicy" />
                        <div class="sa-label agree-txt-label">
                            <span class="lbl">I accept the <a id="termsOfService" class="cursor-pointer" @click=" showTermsPopup  = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Terms of Service</a>
                            and <a id="privacyPolicy" class="cursor-pointer" @click=" showPrivacyPopup = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Privacy Policy</a>.</span>
                        </div>
                    </div>
                    <div v-if="errorText == 'checkTerms'" class="sa-label error-text" style="text-align:left;">Before using {{orgTitle}}, you must read and agree to our terms of service and privacy policy.</div>
                </div> -->
            </div>
        </template>
        <PrivacyPolicy v-if="showPrivacyPopup" @closePopup="closePopup"/>
        <WorbixTermsPopup v-if="showTermsPopup" @closePopup="closePopup"/>
        <div id="panelBackdrop" v-if="showPrivacyPopup || showTermsPopup || mailPopup || existsInOtherSpace"></div>
    </div>
</main>
</template>

<script>
// @ is an alias to /src
import AgentLogo from '@/components/agent-logo.vue'
import FooterLeft from '@/components/footer-left.vue'
import ExistingUser from '@/components/ExistingUser.vue'
import ConfirmBrokerage from '@/components/ConfirmBrokerage.vue'
import Multiselect from 'vue-multiselect'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
import AdminEmail from '@/components/AdminEmail.vue'
import WorbixTermsPopup from '@/components/WorbixTermsPopup.vue'
import {appEnv, worbixServerUrl, invitationLink, relevateUrl, demoNRDS, fakeBrokerageEmail} from '@/properties'
import { mapActions } from "vuex";
export default {
    name: 'State',
    components: {
        AgentLogo,
        ConfirmBrokerage,
        FooterLeft,
		Multiselect,
        WorbixTermsPopup,
        ExistingUser,
        PrivacyPolicy,
        AdminEmail
    },
    data(){
        return{
            selectedOffice:{},
            officeList	:[],
            teamKey:"",
            officeName:"",
            allowMail:false,
            termsOfService:false,
            errorText:'',
            switchToNewOffice :false,
            existsInOtherSpace:false,
            agentInfo:null,
            office:{},
            mailData:null,
            validateOfficeUI : true,
            officeDetailUI : false,
            agentEmail :'',
            loginLink:null,
            inviteStatus:null,
            loadingAgentData:false,
            showTermsPopup:false,
            showPrivacyPopup:false,
            mailPopup:false,
        }
    },
	mounted(){
        this.loginLink = worbixServerUrl;
	},
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        }
    },
	methods:{
        ...mapActions({
            getOfficeData: "getOfficeData",
        }),
		async getTeamDetails(){
            if (!this.teamKey) {
                this.errorText = 'enterKey'
                return;
            }
            if (this.teamKey && (!this.validateNumber(this.teamKey) || this.teamKey.length < 4)) {
                this.errorText = 'wrongFormat'
                return;
            }
            if (!this.termsOfService) {
                this.errorText = 'checkTerms'
                return;
            }

			let payload = {
				officeId : this.teamKey
			}
            this.loadingAgentData = true;
            let officeResponse = await this.getOfficeData(payload);
            if (officeResponse && !Object.keys(officeResponse).length) {
                this.errorText = 'wrongInfo';
                this.loadingAgentData = false;
                return;
            }else {
                this.loadingAgentData = false;
                this.validateOfficeUI = false;
                this.officeDetailUI = true;
                this.selectedOffice = officeResponse
            }
		},
        moveToSignup(){
            if (!this.officeName) {
                this.errorText = 'enterOffice'
                return;
            }
            this.loadingAgentData = true;
            console.log(relevateUrl);
            setTimeout(()=>{
                window.location.href = `${relevateUrl}request?type=REALESTATE&title=${this.officeName}&signupAs=Team&officeId=${this.selectedOffice.results[0].OfficeReference}`;
            }, 20);
        },
        resetError(evt){
            let code = (evt.keyCode ? evt.keyCode : evt.which);
            if (code != 13) {
                this.errorText = '';
                return
            }
            this.getTeamDetails()
        },
        validateNumber(number){
            const re = /^[0-9]+$/;
            return re.test(number);
        },
        closePopup(){
            this.showPrivacyPopup = false;
            this.showTermsPopup = false;
            this.mailPopup = false;
        }
	}
}
</script>

<style>
.error-wrapper{
    text-align: left;
    color: #ffffff;
    background-color: #db082b;
    border-color: #a00620;
    padding: 15px;
    border-radius: 4px;
    width: 500px;
    font-size: 25px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding-top: 25px;
}

.error-wrapper .fa{
    position: absolute;
    right: 8px;
    top: 5px;
    cursor: pointer;
}

.multiselect.form-control.multi-dropdown {
	padding: 0;
	height: auto;
}
.multi-select .multiselect.form-control.multi-dropdown {
    border: 1 #e1e1e1 solid;
	height:98px
}

.multi-select .multiselect__tags{
	border:0px;
	font-size:14px;
	font-family:inherit;
	height:98px
}

.multi-select .multiselect__select{
	height:98px
}

.multi-select .multiselect__single{
	font-size:45px;
	color:#666666;
	font-weight:300;
	display: inline-flex;
	align-items: center;
	height:100%;
	overflow:hidden;
	white-space: nowrap;
}

.multi-select .multiselect__input{
	font-size:45px;
	color:#666666;
	font-weight:300;
	height:100%
}

.multi-select .multiselect__element{
	color:#666666;
}

.multi-select .multiselect__option{
    font-size: 1.25rem;
}



</style>
